import axios from "axios";

const API_URL = "https://srinivasafleet.com/api";


const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login?reason=session_revoked";
    }
    return Promise.reject(error);
  }
);

export const getChatUsers = async () => {
  const res = await api.get("/chat/users");
  return res.data;
};

export const getConversations = async () => {
  const res = await api.get("/chat/conversations");
  return res.data;
};

export const getMessages = async (otherUserId) => {
  const res = await api.get(`/chat/conversations/${otherUserId}`);
  return res.data;
};

export const sendMessage = async (
  receiverId,
  message,
  messageType = "text",
  fileUrl = null,
  fileName = null
) => {
  const res = await api.post("/chat/send", {
    receiver_id: receiverId,
    message,
    message_type: messageType,
    file_url: fileUrl,
    file_name: fileName,
  });
  return res.data;
};

export const uploadChatFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post("/chat/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const resolveFileUrl = (fileUrl) => {
  if (!fileUrl) return fileUrl;
  if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
  return `${API_URL}${fileUrl.startsWith("/") ? "" : "/"}${fileUrl}`;
};

export const markConversationRead = async (userId) => {
  const res = await api.post(`/chat/read/${userId}`);
  return res.data;
};

export function subscribeToChat(onMessage) {
  const token = localStorage.getItem("token");
  const es = new EventSource(`${API_URL}/chat/stream?token=${token}`);

  es.addEventListener("message", (e) => {
    onMessage(JSON.parse(e.data));
  });

  es.onerror = () => {
  };

  return () => es.close();
}